/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isMotionValue as o}from"../utils/is-motion-value.js";function t(t){return Boolean(o(t)&&t.add)}export{t as isWillChangeMotionValue};
//# sourceMappingURL=is.js.map
